var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9205 0.999427C1.48116 0.560087 0.768845 0.560087 0.329505 0.999427C-0.109835 1.43877 -0.109835 2.15108 0.329505 2.59042L6.2007 8.46161L0.32955 14.3328C-0.10979 14.7721 -0.10979 15.4844 0.32955 15.9237C0.76889 16.3631 1.4812 16.3631 1.92054 15.9237L7.79169 10.0526L13.6628 15.9237C14.1022 16.3631 14.8145 16.3631 15.2538 15.9237C15.6932 15.4844 15.6932 14.7721 15.2538 14.3328L9.38268 8.46161L15.2539 2.59042C15.6932 2.15108 15.6932 1.43877 15.2539 0.999427C14.8145 0.560087 14.1022 0.560087 13.6629 0.999427L7.79169 6.87062L1.9205 0.999427Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.64f36ca014c78d0dbbd369114ac2d8d7.svg";
export { ForwardRef as ReactComponent };